import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetI9OnboardingLinkRequest } from "./getI9OnboardingLinkSchema";

export const getI9OnboardingLink = (axios: IAxiosInstance) => {
  return async (data: TGetI9OnboardingLinkRequest) => {
    const response = await axios.noRetry.post<ZealApiResponse<string>>(
      `/api/getEmployeeI9OnboardingLink`,
      { ...data }
    );
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
